export default "__VITE_ASSET__3$ThU7$m__"